import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLargeTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 7.87695L22.2781 13.9882L21.5115 15.2775L12.0001 9.62208L2.48878 15.2775L1.72217 13.9882L12.0001 7.87695Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeTop;
